// @flow
export const ENCRYPT_VALUES = 'ENCRYPT'
export const DECRYPT_VALUES = 'DECRYPT'
export const UPDATE_ENCRYPTION_STATE = 'encryption/update_state'

const encryption = (
  state = { hasEncrypted: false, isProcessing: false, decrypted: {} },
  action
) => {
  switch (action.type) {
    case ENCRYPT_VALUES:
      return {
        hasEncrypted: false,
        isProcessing: true,
        decrypted: {}
      }
    case DECRYPT_VALUES:
      return state
    case UPDATE_ENCRYPTION_STATE:
      return {
        hasEncrypted: true,
        isProcessing: false,
        ...action.payload
      }
    default:
      return state
  }
}

export const updateEncryptionState = values => {
  return {
    type: UPDATE_ENCRYPTION_STATE,
    payload: {
      ...values
    }
  }
}

export const encryptValues = values => {
  return {
    type: ENCRYPT_VALUES,
    payload: {
      ...values
    }
  }
}

export const decryptValues = () => {
  return {
    type: DECRYPT_VALUES,
    payload: {}
  }
}

export default encryption
export * from './sagas.js'



// WEBPACK FOOTER //
// ./src/ducks/encryption/index.js